module.exports = __webpack_public_path__ + "static/img/xueshu6.d01bfee6.webp";